import { MouseEventHandler, useCallback } from 'react';
import ConfiguratorDuck from '../redux/configurator/configurator.duck';
import UIDuck from '../redux/commonDucks/ui.duck';
import { useDispatch } from 'react-redux';
import { useConfiguratorDuck } from '@hooks/useConfiguratorDuck';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useGTM } from '@hooks/useGTM';
import { useUILoadingOnConfigurator } from '@hooks/useUILoadingOnConfigurator';

export const useCompareEngines = (disableSelection?: boolean, displayBackBtn?: boolean) => {
    const dispatch = useDispatch();
    const { motorizations } = useConfiguratorDuck();
    const { carDetails } = useCarDetailsDuck();
    const { pushUserAction } = useGTM();
    const { uiIsLoading } = useUILoadingOnConfigurator();

    const onClickEngineComparator = useCallback(
        (motorisation) => {
            if (!uiIsLoading) {
                pushUserAction({
                    action: 'Choose::Motorization',
                    eventName: 'uaevent',
                    label: motorisation.title,
                });
                dispatch(ConfiguratorDuck.setMotorization(motorisation));
            }
        },
        [carDetails, motorizations, uiIsLoading, dispatch]
    );

    const openEngineModal: MouseEventHandler = (e) => {
        e.preventDefault();
        dispatch(
            UIDuck.openModal({
                data: { motorizations, disableSelection, displayBackBtn },
                callbacks: { onClick: (status: string, ...args) => onClickEngineComparator(args[0]) },
                modalType: UIDuck.MODAL_TYPES.ENGINE_COMPARE,
            })
        );
    };

    return {
        openEngineModal,
        onClickEngineComparator,
    };
};
